import { Injectable } from "@angular/core";
import { BehaviorSubject, combineLatest, forkJoin } from "rxjs";
import { AppointmentsApi, GetAppointmentStatsRequest, GetMobileStatsRequest, GetPrescriptionsStatsRequest, MobileApi, PrescriptionApi } from "../api/proxies";
import { shareReplay, switchMap } from "rxjs/operators";
import { endOfMonth, startOfDay, startOfMonth } from "date-fns";
import { RangePickerPeriod, RangePickerState } from "../range-picker/range-picker-component.store";

@Injectable({ providedIn: 'root' })
export class StatsService {
    private _period$ = new BehaviorSubject<RangePickerState>({
        period: RangePickerPeriod.monthly,
        periodStart: startOfMonth(new Date()),
        periodEnd: startOfDay(endOfMonth(new Date()))
    });

    readonly period$ = this._period$.asObservable();
    public _tenant$ = new BehaviorSubject<any | null>(null);

    constructor(
        private _appointmentsApi: AppointmentsApi,
        private _mobileApi: MobileApi,
        private _prescriptionApi: PrescriptionApi
    ) {
    }

    readonly stats$ = combineLatest([this._period$, this._tenant$]).pipe(
        switchMap(([period, tenant]) => {
            const appReq = new GetAppointmentStatsRequest();
            appReq.start = period.periodStart;
            appReq.end = period.periodEnd;
            appReq.tenantId = tenant?.id;

            const prescReq = new GetPrescriptionsStatsRequest();
            prescReq.start = period.periodStart;
            prescReq.end = period.periodEnd;
            prescReq.tenantId = tenant?.id;

            const mobileReq = new GetMobileStatsRequest();
            mobileReq.start = period.periodStart;
            mobileReq.end = period.periodEnd;
            mobileReq.tenantId = tenant?.id;

            return forkJoin({
                appointment: this._appointmentsApi.stats(appReq),
                prescription: this._prescriptionApi.history(prescReq),
                mobile: this._mobileApi.stats(mobileReq)
            });
        }),
        shareReplay(1)
    );

    updatePeriod(state: RangePickerState) {
        this._period$.next(state);
    }

    selectTenant(client: any | null) {
        this._tenant$.next(client);
    }
}